import { render } from "./IncludedItemOther.vue?vue&type=template&id=7d70e2b9"
import script from "./IncludedItemOther.vue?vue&type=script&lang=js"
export * from "./IncludedItemOther.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__